import api from '../../utils/api'

const API_BASE_URL = "/admin/ADPMemo";

const ADPMemoService = {
    async findAll(recordFilter: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`,
            { params: recordFilter }
        );
        return response.data;
    },

    async findOne(id: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${id}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(id: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${id}`, item);
        return response.data;
    },

    async delete(id: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${id}`);
        return response.data;
    },
};

export default ADPMemoService;